import { render, staticRenderFns } from "./ModalXl.vue?vue&type=template&id=312bfce4&"
import script from "./ModalXl.vue?vue&type=script&lang=js&"
export * from "./ModalXl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports